import React from "react";
import BackgroundLogo from "./BackgroundLogo";
import PageFooter from "./PageFooter";

interface PageLayoutProps {
  children: React.ReactNode;
  logo?: string | null;
  clientName?: string | null;
  title?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  logo,
  clientName,
  title,
}) => {
  return (
    <div
      className="relative p-6 space-y-8 max-w-screen-xl mx-auto min-h-screen"
      style={{ paddingTop: "96px" }}
    >
      {logo && (
        <div className="absolute inset-0 z-0">
          <BackgroundLogo src={logo} alt={`${clientName} logo`} />
        </div>
      )}
      <div className="relative z-10">
        {title && <h1 className="text-2xl font-semibold mb-4">{title}</h1>}
        {children}
      </div>
      <PageFooter logo={logo} clientName={clientName} />
    </div>
  );
};

export default PageLayout;
